import { pick, prop } from 'ramda';

import { useAppSelector, useDeviceSelector, useGameConfigurationSelector, useUserSelector } from '@core/js/store/hooks';

import { LOBBY_NAME_MAP } from '../../constants';

interface ReturnedValue {
    bingoRegion: string;
    casinoName: string;
    lobbyName: string;
    games: Record<string, any>;
}

interface LocationItem {
    countryCode: string;
    currency: string;
    region: string;
}

interface AppSelectorReturnedValue {
    locationJson: {
        items: Array<LocationItem>;
    };
    casinoName: string;
    defaultBingoRegion: any;
    games: Record<string, any>;
}

interface CallbackProps {
    currency: string;
    countryCode: string;
}

const useGetDataForApiCall = (): ReturnedValue => {
    const { country, currencyCode } = useUserSelector(pick(['country', 'currencyCode']));
    const { locationJson, casinoName, defaultBingoRegion } = useAppSelector(pick([
        'locationJson', 'casinoName', 'defaultBingoRegion'
    ])) as AppSelectorReturnedValue;
    const games = useGameConfigurationSelector(prop('games'));
    const formFactor = useDeviceSelector(prop('formFactor'));

    const lobbyName = LOBBY_NAME_MAP[formFactor] || LOBBY_NAME_MAP.desktop;
    const items = locationJson ? locationJson.items : [];
    const regionItem = items.find(({
        currency, countryCode
    }: CallbackProps): boolean => currency === currencyCode && countryCode === country);
    const bingoRegion = regionItem?.region || defaultBingoRegion;

    return { casinoName, lobbyName, bingoRegion, games };
};

export default useGetDataForApiCall;
